// import React, { useEffect, useState } from 'react';
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getAllCateringOrdersAPI,
// } from "../../../Servicefile/CateringSettlementService.jsx";
// const filterButtonStyle = {
//     backgroundColor: "rgb(230 109 51)",
//     color: "white",
//     border: "none",
//     height: '35px',
//     borderRadius: "4px",
//     padding: '0 15px'
// };

// const Cateringsoverview = () => {
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [selectedDate, setSelectedDate] = useState('');
//     const { showLoader, hideLoader } = useLoader();
//     const handleExport = () => {
//         if (filteredData.length === 0) {
//             alert("There is no data to export for the selected date.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = ["S.NO", "Order ID", "Date", "Time", "Category", "Type", "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"];

//         const csvRows = filteredData.map((item, index) => [
//             index + 1,
//             item.orderId || 'N/A',
//             item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : 'N/A',
//             item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A',
//             item.category || 'N/A',
//             item.service || 'N/A',
//             item.userName || 'N/A',
//             item.paymentMethod || 'N/A',
//             item.status || 'N/A',
//             item.grandTotal !== undefined ? Math.round(item.grandTotal) : 'N/A',
//             item.feedback || 'N/A',
//             item.ratings || 'N/A'
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "orders.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     useEffect(() => {
//         const controller =
//             new AbortController();

//         const fetchOrders =
//             async () => {
//                 try {
//                     showLoader();

//                     const orders =
//                         await getAllCateringOrdersAPI(
//                             controller.signal
//                         );

//                     setData(
//                         orders
//                     );

//                     setFilteredData(
//                         orders
//                     );

//                 } catch (err) {
//                     if (
//                         err.name !==
//                         "AbortError"
//                     ) {
//                         console.error(
//                             "Fetching error:",
//                             err
//                         );

//                         setData([]);
//                     }

//                 } finally {
//                     hideLoader();
//                 }
//             };

//         fetchOrders();

//         return () =>
//             controller.abort();

//     }, []);

//     // Filter when date changes
//     useEffect(() => {
//         if (!selectedDate) {
//             setFilteredData(data);
//             return;
//         }

//         const selected = new Date(selectedDate);
//         selected.setHours(0, 0, 0, 0);
//         const nextDay = new Date(selected);
//         nextDay.setDate(selected.getDate() + 1);

//         const filtered = data.filter(item => {
//             const orderDate = new Date(item.orderDateAndTime);
//             return orderDate >= selected && orderDate < nextDay;
//         });

//         setFilteredData(filtered);
//     }, [selectedDate, data]);

//     return (
//         <div>
//             <div className="row" style={{ marginTop: '-5px' }}>
//                 <div className="col-lg-12 col-md-12 col-sm-12 col-12">
//                     <div style={{ overflowY: 'auto', height: 'calc(85vh - 40px)', scrollbarWidth: 'none' }}>
//                         {/* Date Picker and Export Button */}
//                         <div
//                             className="d-flex flex-wrap align-items-center mb-2 pt-3 rounded ps-0"
//                             style={{ gap: "10px" }}
//                         >
//                             <div>
//                                 <input
//                                     type="date"
//                                     value={selectedDate}
//                                     onChange={(e) => setSelectedDate(e.target.value)}
//                                     style={filterSelectStyle}
//                                 />
//                             </div>

//                             <div style={{ marginLeft: "auto" }}>
//                                 <button
//                                     type="button"
//                                     className="btn btn-sm fw-bold"
//                                     style={filterButtonStyle}
//                                     onClick={handleExport}
//                                 >
//                                     Export
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Orders Table */}
//                         <div className="table-responsive rr pe-2">
//                             <table
//                                 className="table-striped table-bordered align-middle"
//                                 style={{ fontSize: "0.95rem", width: "100%" }}
//                             >
//                                 <thead>
//                                     <tr>
//                                         <th style={tableHeaderStyle}>OrderID</th>
//                                         <th style={tableHeaderStyle}>VendorID</th>
//                                         <th style={tableHeaderStyle}>Location</th>
//                                         <th style={tableHeaderStyle}>Date</th>
//                                         <th style={tableHeaderStyle}>Time</th>
//                                         <th style={tableHeaderStyle}>Category</th>
//                                         <th style={tableHeaderStyle}>Payment</th>
//                                         <th style={tableHeaderStyle}>Status</th>
//                                         <th style={tableHeaderStyle}>Amount</th>
//                                         <th style={tableHeaderStyle}>Feedback</th>
//                                         <th style={tableHeaderStyle}>Ratings</th>
//                                     </tr>
//                                 </thead>

//                                 <tbody>
//                                     {filteredData.length ? (
//                                         filteredData.map((item, index) => (
//                                             <tr
//                                                 key={item.orderId || index}
//                                                 style={{
//                                                     backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
//                                                 }}
//                                             >
//                                                 <td style={tableCellStyle}>{item.orderId || "-"}</td>
//                                                 <td style={tableCellStyle}>#{item.vendorId || "-"}</td>
//                                                 <td style={tableCellStyle}>{item.location || "-"}</td>
//                                                 <td style={tableCellStyle}>
//                                                     {item.orderDateAndTime
//                                                         ? new Date(item.orderDateAndTime).toLocaleDateString()
//                                                         : "-"}
//                                                 </td>
//                                                 <td style={tableCellStyle}>
//                                                     {item.orderDateAndTime
//                                                         ? new Date(item.orderDateAndTime).toLocaleTimeString([], {
//                                                             hour: "2-digit",
//                                                             minute: "2-digit",
//                                                         })
//                                                         : "-"}
//                                                 </td>
//                                                 <td style={tableCellStyle}>{item.orderService || "-"}</td>
//                                                 <td style={tableCellStyle}>{item.paymentMethod || "-"}</td>
//                                                 <td style={tableCellStyle}>{item.paymentStatus || "-"}</td>
//                                                 <td style={tableCellStyle}>
//                                                     ₹{item.total !== undefined ? Math.round(item.total) : "-"}
//                                                 </td>
//                                                 <td style={tableCellStyle}>{item.feedback || "-"}</td>
//                                                 <td style={tableCellStyle}>
//                                                     {[1, 2, 3, 4, 5].map((star) => (
//                                                         <span
//                                                             key={star}
//                                                             style={{
//                                                                 color:
//                                                                     item.ratings && Number(item.ratings) >= star
//                                                                         ? "#FFD700"
//                                                                         : "#e4e5e9",
//                                                                 fontSize: 18,
//                                                                 marginRight: 2,
//                                                             }}
//                                                         >
//                                                             ★
//                                                         </span>
//                                                     ))}
//                                                 </td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="11" style={{ ...tableCellStyle, fontStyle: "italic" }}>
//                                                 No orders found for this date.
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "rgb(230 109 51)",
//     color: "white",
//     padding: 6,
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: 6,
// };
// const filterSelectStyle = {
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     border: "none",
//     height: "35px",
//     borderRadius: "4px"
// };
// export default Cateringsoverview;





import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllCateringOrdersAPI,
} from "../../../Servicefile/CateringSettlementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Calendar: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Order: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    Star: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
    ),
    StarEmpty: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e2e8f0" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    Feedback: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
    ),
    Time: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
       
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginBottom: '16px',
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        border: '1px solid #edf2f7'
    },
    statItem: {
        textAlign: 'center'
    },
    statValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    statLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    dateInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '160px'
    },
    button: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonExport: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    tableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        scrollbarWidth:'none',
        maxHeight: '60vh',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeCompleted: {
        background: '#c6f6d5',
        color: '#276749'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    badgeCancelled: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    badgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    amount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    paymentBadge: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600'
    },
    paymentWallet: {
        background: '#c6f6d5',
        color: '#276749'
    },
    paymentCard: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    paymentCash: {
        background: '#fefcbf',
        color: '#975a16'
    },
    paymentDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    }
};

const Cateringsoverview = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const fetchOrders = async () => {
            try {
                setLoading(true);
                showLoader();
                const orders = await getAllCateringOrdersAPI(controller.signal);
                setData(orders);
                setFilteredData(orders);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Fetching error:", err);
                    setData([]);
                }
            } finally {
                setLoading(false);
                hideLoader();
            }
        };
        fetchOrders();
        return () => controller.abort();
    }, []);

    useEffect(() => {
        if (!selectedDate) {
            setFilteredData(data);
            return;
        }
        const selected = new Date(selectedDate);
        selected.setHours(0, 0, 0, 0);
        const nextDay = new Date(selected);
        nextDay.setDate(selected.getDate() + 1);
        const filtered = data.filter(item => {
            const orderDate = new Date(item.orderDateAndTime);
            return orderDate >= selected && orderDate < nextDay;
        });
        setFilteredData(filtered);
    }, [selectedDate, data]);

    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("There is no data to export for the selected date.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Order ID", "Vendor ID", "Location", "Date", "Time", "Category", "Payment", "Status", "Amount", "Feedback", "Ratings"];

        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.orderId || 'N/A',
            item.vendorId || 'N/A',
            item.location || 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A',
            item.orderService || 'N/A',
            item.paymentMethod || 'N/A',
            item.paymentStatus || 'N/A',
            item.total !== undefined ? Math.round(item.total) : 'N/A',
            item.feedback || 'N/A',
            item.ratings || 'N/A'
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `catering_orders_${selectedDate || 'all'}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const clearDateFilter = () => {
        setSelectedDate('');
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.badgeDefault;
        const lower = status.toLowerCase();
        if (lower === 'completed' || lower === 'delivered' || lower === 'success') return styles.badgeCompleted;
        if (lower === 'cancelled' || lower === 'canceled' || lower === 'failed') return styles.badgeCancelled;
        if (lower === 'pending' || lower === 'processing') return styles.badgePending;
        return styles.badgeDefault;
    };

    const getPaymentBadge = (method) => {
        if (!method) return styles.paymentDefault;
        const lower = method.toLowerCase();
        if (lower.includes('wallet')) return styles.paymentWallet;
        if (lower.includes('card') || lower.includes('credit') || lower.includes('debit')) return styles.paymentCard;
        if (lower.includes('cash')) return styles.paymentCash;
        return styles.paymentDefault;
    };

    // Calculate stats
    const totalOrders = data.length;
    const totalRevenue = data.reduce((sum, item) => sum + (item.total || 0), 0);
    const completedOrders = data.filter(item => item.paymentStatus?.toLowerCase() === 'completed' || item.status?.toLowerCase() === 'completed').length;
    const pendingOrders = data.filter(item => item.paymentStatus?.toLowerCase() === 'pending' || item.status?.toLowerCase() === 'pending').length;

    return (
        <div style={styles.container}>
         
            
            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icons.Calendar />
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={{
                            ...styles.dateInput,
                            borderColor: selectedDate ? '#e66d33' : '#e2e8f0'
                        }}
                    />
                    {selectedDate && (
                        <button
                            onClick={clearDateFilter}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>
                    )}
                </div>

                <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                    <button
                        onClick={handleExport}
                        style={{ ...styles.button, ...styles.buttonExport }}
                    >
                        <Icons.Export /> Export
                    </button>
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '4%' }}>#</th>
                            <th style={{ ...styles.th, width: '8%' }}>Order ID</th>
                            <th style={{ ...styles.th, width: '8%' }}>Vendor ID</th>
                            <th style={{ ...styles.th, width: '10%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Location /> Location
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '8%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Calendar /> Date
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '6%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Time /> Time
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '8%' }}>Category</th>
                            <th style={{ ...styles.th, width: '8%' }}>Payment</th>
                            <th style={{ ...styles.th, width: '8%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Status /> Status
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '8%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Money /> Amount
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '10%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Feedback /> Feedback
                                </div>
                            </th>
                            <th style={{ ...styles.th, width: '8%' }}>Ratings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && data.length === 0 ? (
                            <tr>
                                <td colSpan="12" style={{ padding: 0 }}>
                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ marginTop: '16px', color: '#718096' }}>Loading orders...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <tr
                                    key={item.orderId || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                    <td style={{ ...styles.td, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                        #{item.orderId || "-"}
                                    </td>
                                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                        #{item.vendorId || "-"}
                                    </td>
                                    <td style={styles.td}>{item.location || "-"}</td>
                                    <td style={styles.td}>{formatDate(item.orderDateAndTime)}</td>
                                    <td style={styles.td}>{formatTime(item.orderDateAndTime)}</td>
                                    <td style={styles.td}>
                                        <span style={{
                                            fontSize: '11px',
                                            background: '#edf2f7',
                                            padding: '2px 10px',
                                            borderRadius: '4px',
                                            color: '#4a5568'
                                        }}>
                                            {item.orderService || "-"}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        {item.paymentMethod ? (
                                            <span style={{ ...styles.paymentBadge, ...getPaymentBadge(item.paymentMethod) }}>
                                                {item.paymentMethod}
                                            </span>
                                        ) : "-"}
                                    </td>
                                    <td style={styles.td}>
                                        {item.paymentStatus ? (
                                            <span style={{ ...styles.badge, ...getStatusBadge(item.paymentStatus) }}>
                                                {item.paymentStatus}
                                            </span>
                                        ) : "-"}
                                    </td>
                                    <td style={{ ...styles.td, ...styles.amount }}>
                                        ₹{item.total !== undefined ? Math.round(item.total) : "-"}
                                    </td>
                                    <td style={styles.td}>
                                        {item.feedback ? (
                                            <div style={{
                                                maxWidth: '120px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                cursor: 'pointer',
                                                color: '#4a5568'
                                            }} title={item.feedback}>
                                                {item.feedback}
                                            </div>
                                        ) : "-"}
                                    </td>
                                    <td style={styles.td}>
                                        {item.ratings ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', gap: '2px' }}>
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <span
                                                        key={star}
                                                        style={{
                                                            color: Number(item.ratings) >= star ? '#FFD700' : '#e2e8f0',
                                                            fontSize: '16px'
                                                        }}
                                                    >
                                                        ★
                                                    </span>
                                                ))}
                                            </div>
                                        ) : "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {data.length === 0 ? 'Loading orders...' : 'No orders found'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {data.length === 0
                                                ? 'Please wait while we fetch the data'
                                                : selectedDate
                                                    ? 'No orders found for the selected date'
                                                    : 'No catering orders are available'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <style>{`
                @media (max-width: 768px) {
                    .filters-container {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .stats-container {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .table-container table {
                        font-size: 12px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 8px 10px !important;
                        font-size: 11px !important;
                    }
                }

                @media (max-width: 480px) {
                    .stats-container {
                        grid-template-columns: 1fr !important;
                    }
                    .stat-value {
                        font-size: 18px !important;
                    }
                    .table-container table {
                        font-size: 10px !important;
                        min-width: 800px !important;
                    }
                    .table-container table th,
                    .table-container table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .badge {
                        font-size: 8px !important;
                        padding: 1px 6px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default Cateringsoverview;